import React from 'react';
import { useTranslation } from 'react-i18next';

const Features = () => {
    const { t } = useTranslation();

    return (
        <div className="bg-white py-12">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                    {/* Feature 1 */}
                    <div className="p-6 bg-white rounded-lg">
                        <div className="flex items-center mb-4">
                            <svg className="h-6 w-6 text-[#2E8B57] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <h3 className="text-lg font-medium text-gray-900">
                                {t('features.authenticSources.title')}
                            </h3>
                        </div>
                        <p className="text-sm text-gray-500">
                            {t('features.authenticSources.description')}
                        </p>
                    </div>

                    {/* Feature 2 */}
                    <div className="p-6 bg-white rounded-lg">
                        <div className="flex items-center mb-4">
                            <svg className="h-6 w-6 text-[#2E8B57] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                            </svg>
                            <h3 className="text-lg font-medium text-gray-900">
                                {t('features.interactiveLearning.title')}
                            </h3>
                        </div>
                        <p className="text-sm text-gray-500">
                            {t('features.interactiveLearning.description')}
                        </p>
                    </div>

                    {/* Feature 3 */}
                    <div className="p-6 bg-white rounded-lg">
                        <div className="flex items-center mb-4">
                            <svg className="h-6 w-6 text-[#2E8B57] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129" />
                            </svg>
                            <h3 className="text-lg font-medium text-gray-900">
                                {t('features.multilingualSupport.title')}
                            </h3>
                        </div>
                        <p className="text-sm text-gray-500">
                            {t('features.multilingualSupport.description')}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Features; 